import { createApiRef } from '@backstage/core-plugin-api';
import type {
  AttemptsQuery,
  BuildsQuery,
  GcbId,
  FlakyStep,
  FlakyStepsQuery,
  FlakyTest,
  FlakyTestsQuery,
  FlakyTestsSummary,
  FlakyTestsSummaryQuery,
  LassoBuild,
  LassoBuildLogResponse,
  LassoTestAttempt,
  LassoTestHistoryEntry,
  LassoTraceViewerUrlResponse,
  StacksQuery,
  StatusesQuery,
  TestHistoryQuery,
  TestHistorySummary,
  TestHistorySummaryQuery,
} from '@internal/plugin-lasso-common';

export type BuildsParams = BuildsQuery;
export type AttemptsParams = Omit<AttemptsQuery, 'buildId'>;
export type TestHistoryParams = TestHistoryQuery;
export type TestHistorySummaryParams = TestHistorySummaryQuery;
export type FlakyTestsParams = FlakyTestsQuery;
export type FlakyTestsSummaryParams = FlakyTestsSummaryQuery;
export type FlakyStepsParams = FlakyStepsQuery;
export type StacksParams = StacksQuery;
export type StatusesParams = StatusesQuery;

export interface LassoApi {
  getBuilds(params?: BuildsParams): Promise<LassoBuild[]>;
  getBuild(buildId: string): Promise<LassoBuild | null>;
  getBuildAttempts(
    buildId: string,
    params?: AttemptsParams,
  ): Promise<LassoTestAttempt[]>;
  getTestHistory(params: TestHistoryParams): Promise<LassoTestHistoryEntry[]>;
  getTestHistorySummary(
    params: TestHistorySummaryParams,
  ): Promise<TestHistorySummary>;
  getFlakyTests(params?: FlakyTestsParams): Promise<FlakyTest[]>;
  getFlakyTestsSummary(
    params?: FlakyTestsSummaryParams,
  ): Promise<FlakyTestsSummary>;
  getFlakySteps(params?: FlakyStepsParams): Promise<FlakyStep[]>;
  getTraceViewerUrl(
    testAttemptId: string,
  ): Promise<LassoTraceViewerUrlResponse>;
  getAttempt(testAttemptId: string): Promise<LassoTestAttempt>;
  getStacks(params?: StacksParams): Promise<string[]>;
  getStatuses(params?: StatusesParams): Promise<(string | null)[]>;
  getBuildLog(
    buildId: string,
    gcbId: GcbId,
  ): Promise<LassoBuildLogResponse | null>;
}

export const lassoApiRef = createApiRef<LassoApi>({
  id: 'plugin.lasso.service',
});
